import { ArticleModel, RimTyresSearchModel, TyreSearchModel } from '@/types/api'
import { createUrlQuery } from '@/utils/apiHelper'
import { baseApi } from './baseApi'

const tyresApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTyres: builder.query<ArticleModel[], TyreSearchModel>({
      query: (payload) => `Tyres?${createUrlQuery(payload)}`,
      providesTags: (result, error, arg) => [{ type: 'Search', id: 'LIST' }],
      keepUnusedDataFor: 300,
    }),
    getRimTyres: builder.query<ArticleModel[], RimTyresSearchModel>({
      query: (payload) => `RimTyres?${createUrlQuery(payload)}`,
      providesTags: (result, error, arg) => [{ type: 'Search', id: 'LIST' }],
      keepUnusedDataFor: 300,
    }),
  }),
})

export const { useLazyGetTyresQuery, useLazyGetRimTyresQuery } = tyresApi